import { channelTypes } from "../../../utils/constants"

export const channels_selectChannelsLoading = (state) => state.channels.channelsLoading
export const channels_selectChannels = (state) => state.channels.channels

const qrChannelSelectorsMap = {
   [channelTypes.WHATSAPP]: {
      qrLoading: (state) => state.channels.qrLoading,
      qrCode: (state) => state.channels.qrCode,
      sourceId: (state) => state.channels.sourceId
   },
   [channelTypes.MAX]: {
      qrLoading: (state) => state.channels.maxQrLoading,
      qrCode: (state) => state.channels.maxQrCode,
      sourceId: (state) => state.channels.maxSourceId
   }
}

export const channels_selectQrChannelState = (state, channelType) => ({
   qrLoading: qrChannelSelectorsMap[channelType]?.qrLoading(state),
   qrCode: qrChannelSelectorsMap[channelType]?.qrCode(state),
   sourceId: qrChannelSelectorsMap[channelType]?.sourceId(state)
})

export const channels_selectQrLoading = (state) => channels_selectQrChannelState(state, channelTypes.WHATSAPP).qrLoading
export const channels_selectQrCode = (state) => channels_selectQrChannelState(state, channelTypes.WHATSAPP).qrCode
export const channels_selectSourceId = (state) => channels_selectQrChannelState(state, channelTypes.WHATSAPP).sourceId
export const channels_selectMaxQrLoading = (state) => channels_selectQrChannelState(state, channelTypes.MAX).qrLoading
export const channels_selectMaxQrCode = (state) => channels_selectQrChannelState(state, channelTypes.MAX).qrCode
export const channels_selectMaxSourceId = (state) => channels_selectQrChannelState(state, channelTypes.MAX).sourceId